<div class="formGroup row table" *ngIf="!options?.isOutTable">
  <div class="container">
    <table class="filterPageTable">
      <caption style="display: none">
        Texto prueba
      </caption>
      <tbody class="filterPageTableBody">
        <tr class="row filterRow" [ngStyle]="options?.style">
          <td
            class="itemContainer col xxsColCheckbox checkboxCol"
            *ngIf="options && options.showCheckbox"
          >
            <!-- Empty div for checkbox space in filter -->
          </td>
          <td
            class="col {{ item.size }} "
            [ngClass]="{ inTableColFilter: options && options.isMastertable }"
            [ngStyle]="item.style"
            *ngFor="let item of filterList; let i = index"
          >
            <div *ngIf="item.type == 'text'">
              <div
                class="itemContainer col seachLabel inputLabelForm fixGapText"
              >
                <span class="inputLabel">{{ item.label }}</span>
              </div>
              <div
                *ngIf="
                  item.label == 'Número de solicitud' ||
                    item.label == 'Bastidor' ||
                    item.label == 'Matrícula';
                  then mayusText;
                  else normalText
                "
              ></div>
              <ng-template #mayusText>
                <div class="inputTextForm">
                  <input
                    (keyup.enter)="pressEnter()"
                    class="inputSearch"
                    name="{{ item.label }}"
                    type="text"
                    [(ngModel)]="filtersValuesSearch[i]"
                    toUppercase
                  />
                </div>
              </ng-template>
              <ng-template #normalText>
                <div class="inputTextForm">
                  <input
                    (keyup.enter)="pressEnter()"
                    class="inputSearch"
                    name="{{ item.label }}"
                    type="text"
                    [(ngModel)]="filtersValuesSearch[i]"
                  />
                </div>
              </ng-template>
              <div class="extraTextContainer">
                <div class="inputExtraText"></div>
              </div>
            </div>

            <div *ngIf="item.type == 'number'">
              <div
                class="itemContainer col seachLabel inputLabelForm fixGapText"
              >
                <span class="inputLabel">{{ item.label }}</span>
              </div>
              <div class="inputTextForm">
                <input
                  (keyup.enter)="pressEnter()"
                  class="inputSearch"
                  name="{{ item.label }}"
                  type="number"
                  [(ngModel)]="filtersValuesSearch[i]"
                />
              </div>
              <div class="extraTextContainer">
                <div class="extraText"></div>
              </div>
            </div>

            <div *ngIf="item.type == 'date'">
              <div
                class="itemContainer col seachLabel inputLabelForm fixGapText"
              >
                <span class="inputLabel">{{ item.label }}</span>
              </div>
              <div class="inputTextForm" *ngIf="!item.multiple">
                <input
                  (keyup.enter)="pressEnter()"
                  class="inputSearch"
                  name="{{ item.label }}"
                  type="date"
                  [(ngModel)]="filtersValuesSearch[i]"
                />
              </div>
              <div class="inputTextForm" *ngIf="item.multiple">
                <input
                  (keyup.enter)="pressEnter()"
                  class="inputSearch"
                  name="{{ item.label }}"
                  type="date"
                  [(ngModel)]="filtersValuesSearch[i]"
                />

                <input
                  (keyup.enter)="pressEnter()"
                  class="inputSearch"
                  name="{{ item.label }}"
                  type="date"
                  [(ngModel)]="item.secondField.value"
                />
              </div>
              <div class="extraTextContainer">
                <div class="inputExtraText"></div>
              </div>
            </div>

            <div *ngIf="item.type == 'select'">
              <div
                class="itemContainer col seachLabel inputLabelForm fixGapText"
              >
                <span class="inputLabel">{{ item.label }}</span>
              </div>
              <div class="inputTextForm">
                <app-input-selector-with-search
                  #inputSearch
                  [list]="item.selectorConf.dataList"
                  [fields]="item.selectorConf.fields"
                  [id]="item.selectorConf.id"
                  [item]="getValueOfSelector(item)"
                  (sendValue)="valueSelector($event)"
                  (pressEnter)="pressEnter()"
                ></app-input-selector-with-search>
              </div>
            </div>

            <div *ngIf="item.type == ''">
              <div
                class="itemContainer col seachLabel inputLabelForm fixGapText"
              >
                <span class="inputLabel">{{ item.label }}</span>
              </div>
              <div class="inputTextForm"></div>
              <div class="extraTextContainer">
                <div class="inputExtraText"></div>
              </div>
            </div>
          </td>
          <th class="col xsColButton" id="buttonHeaders">
            <div class="smallHeaderButtons">
              <div class="buttonContainer searchContainer"></div>

              <div class="buttonContainer filterContainer"></div>
            </div>
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div
  class="formGroup row table filtersOut"
  *ngIf="options && options.isOutTable"
  [ngClass]="{
    filtersOutExpandido: filtersToggled,
    filtersOutToggled: !filtersToggled
  }"
>
  <div class="container">
    <table class="filterPageTable">
      <caption style="display: none">
        Texto prueba
      </caption>

      <tbody class="filterPageTableBody">
        <tr class="row filterRow" [ngStyle]="options?.style">
          <th style="display: none"></th>
          <td
            class="itemContainer col xxsColCheckbox checkboxCol"
            *ngIf="options && options.showCheckbox"
          >
            <!-- Empty div for checkbox space in filter -->
          </td>
          <ng-container *ngFor="let item of filterList; let i = index">
            <td
              class="col {{ item.size }} autogenCol"
              [ngStyle]="item.style"
              [ngClass]="{ filtersOutComprimido: !filtersToggled }"
            >
              <ng-container *ngIf="!item.hide">
                <div *ngIf="item.type == 'text'">
                  <div
                    class="itemContainer col seachLabel inputLabelForm fixGapText"
                  >
                    <span class="inputLabel">{{ item.label }}</span>
                  </div>
                  <div class="inputTextForm">
                    <input
                      (keyup.enter)="pressEnter()"
                      class="inputSearch"
                      name="{{ item.label }}"
                      type="text"
                      [(ngModel)]="filtersValuesSearch[i]"
                    />
                  </div>
                  <div class="extraTextContainer">
                    <div class="inputExtraText"></div>
                  </div>
                </div>

                <div *ngIf="item.type == 'number'">
                  <div
                    class="itemContainer col seachLabel inputLabelForm fixGapText"
                  >
                    <span class="inputLabel">{{ item.label }}</span>
                  </div>
                  <div class="inputTextForm">
                    <input
                      (keyup.enter)="pressEnter()"
                      class="inputSearch"
                      name="{{ item.label }}"
                      type="number"
                      [(ngModel)]="filtersValuesSearch[i]"
                    />
                  </div>
                  <div class="extraTextContainer">
                    <div class="extraText"></div>
                  </div>
                </div>

                <div *ngIf="item.type == 'date'">
                  <div
                    class="itemContainer col seachLabel inputLabelForm fixGapText"
                  >
                    <span class="inputLabel">{{ item.label }}</span>
                  </div>
                  <div class="inputTextForm" *ngIf="!item.multiple">
                    <input
                      (keyup.enter)="pressEnter()"
                      class="inputSearch"
                      name="{{ item.label }}"
                      type="date"
                      [(ngModel)]="filtersValuesSearch[i]"
                    />
                  </div>
                  <div class="inputTextForm" *ngIf="item.multiple">
                    <input
                      (keyup.enter)="pressEnter()"
                      class="inputSearch"
                      name="{{ item.label }}"
                      type="date"
                      [(ngModel)]="filtersValuesSearch[i]"
                    />

                    <input
                      (keyup.enter)="pressEnter()"
                      class="inputSearch"
                      name="{{ item.label }}"
                      type="date"
                      [(ngModel)]="item.secondField.value"
                    />
                  </div>
                  <div class="extraTextContainer">
                    <div class="inputExtraText"></div>
                  </div>
                </div>

                <div *ngIf="item.type == 'select'">
                  <div
                    class="itemContainer col seachLabel inputLabelForm fixGapText"
                  >
                    <span class="inputLabel">{{ item.label }}</span>
                  </div>
                  <div class="inputTextForm">
                    <app-input-selector-with-search
                      #inputSearch
                      [list]="item.selectorConf.dataList"
                      [fields]="item.selectorConf.fields"
                      [id]="item.selectorConf.id"
                      [item]="getValueOfSelector(item)"
                      (sendValue)="valueSelector($event)"
                      (pressEnter)="pressEnter()"
                    ></app-input-selector-with-search>
                  </div>
                </div>

                <div *ngIf="item.type == 'empty'">
                  <div
                    class="itemContainer col seachLabel inputLabelForm fixGapText"
                  >
                    <span class="inputLabel"></span>
                  </div>
                  <div class="inputTextForm"></div>
                </div>
              </ng-container>
            </td>
          </ng-container>

          <td class="autogenCol col xsColButton" *ngIf="filtersToggled">
            <div>
              <span class="inputLabel"></span>
            </div>
            <div class="inputTextForm" [ngStyle]="{ 'padding-left': '13px' }">
              <button class="submitSearchButton" (click)="toggleFilterButton()">
                <em _ngcontent-xov-c105="" class="fas fa-filter"></em>
              </button>
            </div>
          </td>
          <td
            class="autogenCol col largeCol"
            *ngIf="!filtersToggled"
            [ngClass]="{ filtersOutComprimidoButton: !filtersToggled }"
          >
            <div class="buttonFiltrosAmpliados">
              <span> {{ titleOutTable }} </span>
              <button class="submitSearchButton" (click)="toggleFilterButton()">
                <em _ngcontent-xov-c105="" class="fas fa-filter"></em>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
